<div *ngIf="show" class="gl-dialog-overlay" (click)="cancelGLEntries()">
  <div class="gl-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <h3>GL String </h3>
    <table class="table" style="width:auto">
      <tbody>
        <tr>
          <td><strong>Order Total</strong></td>
          <td style="text-align: right;">{{ getOrderTotal() | number:'1.2-2' }}</td>
        </tr>
        <tr>

          <td><strong>Open Order Total</strong></td>
          <td style="text-align: right;">
            {{ getOpenOrderTotal() | number:'1.2-2' }}

          </td>

        </tr>
      </tbody>
    </table>

    <table class="table">
      <thead>
        <tr>
          <th>Date</th>
          <th>GL String</th>
          <th *ngIf="showInvoiceColumn">Invoice #</th>
          <th class="text-right">$ Amount</th>
          <th class="text-right">%</th>
          <th class="text-right">Sales Tax</th>
          <th class="text-right">Total</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of glEntries; let i = index" [class.gl-row-locked]="row.blurred">
          <td>
            <input class="form-control" [value]="row.Date | date:'MM/dd/yyyy'" [disabled]="row.blurred">
          </td>
  <td>
<input
  #glInput
  class="form-control"
  [value]="row.glString"
  (input)="onChangeGLString(glInput.value, i)"
  (keypress)="allowOnlyValidInput($event, i)"
  [disabled]="row.blurred"
  maxlength="27"
/>


  <small class="text-danger" *ngIf="row.glStringError">
    GL String does not meet Accounting requirements, please verify and enter again.
  </small>
</td>

          <td *ngIf="showInvoiceColumn">
            <input class="form-control" [(ngModel)]="row.invoiceId" [disabled]="row.blurred">
          </td>

          <td class="text-right">
            <input class="form-control text-right" type="number" step="0.01" [disabled]="row.blurred"
              [(ngModel)]="row.amount" (ngModelChange)="onAmountChange($event, i)">
          </td>

          <td class="text-right">
            <input class="form-control text-right" type="number" step="0.01" [disabled]="row.blurred"
              [(ngModel)]="row.percent" (ngModelChange)="onPercentChange($event, i)">
          </td>

          <td class="text-right">
            <input class="form-control text-right" type="number" step="0.01" [disabled]="row.blurred"
              [(ngModel)]="row.tax" (ngModelChange)="onTaxChange($event, i)">
          </td>

          <td class="text-right">
            {{ row.total | number:'1.2-2' }}
          </td>

          <td class="gl-actions">
            <button class="uitk-icon uitk-icon-trash_delete gridIcons" (click)="deleteGLRow(i)"
              [disabled]="row.blurred"></button>
          </td>
        </tr>
      </tbody>

      <!-- ✅ FIXED TOTALS ROW -->
      <tfoot>
        <tr class="gl-totals-row">

          <!-- Date column -->
          <td></td>

          <!-- GL String column -->
          <td><strong>Total</strong></td>

          <!-- Invoice column (only if shown) -->
          <td *ngIf="showInvoiceColumn"></td>

          <!-- $ Amount -->
          <td class="text-right">
            <strong>{{ totalAmount() | number:'1.2-2' }}</strong>
          </td>

          <!-- % -->
          <td class="text-right">
            <strong>{{ totalPercent() | number:'1.2-2' }}%</strong>
          </td>

          <!-- Sales Tax -->
          <td class="text-right">
            <strong>{{ totalTax() | number:'1.2-2' }}</strong>
          </td>

          <!-- Total -->
          <td class="text-right">
            <strong>{{ totalOfTotals() | number:'1.2-2' }}</strong>
          </td>

          <!-- Actions -->
          <td></td>
        </tr>
      </tfoot>
    </table>
    <div class="d-flex justify-content-between">
      <button class="uitk-c-button uitk-c-button--ghost" (click)="addGLRow()" [disabled]="hasNoRemainingAmount()">+ Add GL String</button>
      <div>
        <button class="uitk-c-button uitk-c-button--ghost" (click)="cancelGLEntries()">Cancel</button>
        <button 
  class="uitk-c-button uitk-c-button--ghost" 
  (click)="saveGLEntries()"
  [disabled]="hasGLStringErrors()"
>
  Save
</button>
      </div>
    </div>

    <div class="gl-inline-alert" *ngIf="showReadjustPrompt">
      <div class="gl-inline-alert__msg">
        The Order Total does not match the saved GL Total. Do you want to re-adjust GL amounts (keeping the same percentage distribution)?
      </div>
      <button type="button" class="uitk-c-button uitk-c-button--ghost" (click)="rebalanceByPercent()">Yes</button>
      <button type="button" class="uitk-c-button uitk-c-button--ghost" (click)="dismissReadjustPrompt()">No</button>
    </div>

    <div class="gl-inline-alert" *ngIf="showInlineAlert">
      <div class="gl-inline-alert__msg">
        {{ errorMessage }}
      </div>
      <button type="button" class="uitk-c-button uitk-c-button--ghost" (click)="onInlineAlertOk()">OK</button>
    </div>

  </div>
</div>